module.exports = __webpack_public_path__ + "img/prepended-letter.2dc1beac.svg";